module.exports = __webpack_public_path__ + "notif-group-icons.png?95f493b088a5daf770a9cdd050df4483";